"use client";
import React, { useState } from "react";
import { useRouter } from "next/navigation";

const BackBtn: React.FC<{ dark?: boolean }> = ({ dark }) => {
  const router = useRouter();
  const handleBack = () => {
    router.back();
  };
  return (
    <button
      className={`flex text-white gap-2 ${dark && "!text-primary"}`}
      onClick={handleBack}
    >
      <BackIcon />
    </button>
  );
};

export default BackBtn;

export const BackIcon: React.FC = () => {
  const [hovered, setHovered] = useState(false);
  return (
    <svg
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="40"
        height="40"
        rx="20"
        className="transition-all duration-500"
        fill={hovered ? "var(--primary-color)" : "white"}
      />
      <path
        className="transition-all duration-500"
        d="M22.9726 27.4824C23.0538 27.5682 23.1172 27.6693 23.1593 27.7796C23.2015 27.89 23.2214 28.0076 23.2181 28.1257C23.2147 28.2438 23.1882 28.3601 23.1399 28.468C23.0916 28.5758 23.0225 28.6731 22.9367 28.7542C22.8508 28.8354 22.7498 28.8988 22.6394 28.9409C22.529 28.983 22.4114 29.003 22.2933 28.9996C22.1752 28.9963 22.0589 28.9697 21.9511 28.9214C21.8432 28.8732 21.746 28.8041 21.6648 28.7182L14.0193 20.623C13.8614 20.456 13.7734 20.2349 13.7734 20.0051C13.7734 19.7752 13.8614 19.5541 14.0193 19.3871L21.6648 11.291C21.7454 11.2032 21.8427 11.1324 21.9509 11.0825C22.0591 11.0326 22.1762 11.0048 22.2953 11.0006C22.4144 10.9963 22.5331 11.0158 22.6446 11.0579C22.7561 11.0999 22.8581 11.1637 22.9448 11.2455C23.0314 11.3273 23.1009 11.4255 23.1493 11.5344C23.1976 11.6433 23.2239 11.7608 23.2265 11.8799C23.2291 11.999 23.208 12.1175 23.1644 12.2284C23.1208 12.3393 23.0556 12.4404 22.9726 12.5259L15.91 20.0051L22.9726 27.4824Z"
        fill={hovered ? "white" : "var(--primary-color)"}
      />
    </svg>
  );
};
